import createModalSkeleton from "src/helpers/createModalSkeleton";

const { RecapModalSkeleton, useRecapModalDimensions } = createModalSkeleton({
	name: "RecapModal",
	sizeVariant: "Medium",
});
export { useRecapModalDimensions };
export default RecapModalSkeleton;
